import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountInfoCreationComponent } from './account-info-creation/account-info-creation.component';
import { DetailAccountCreationComponent } from './detail-account-creation/detail-account-creation.component';
import { SuccessfulAccountCreationComponent } from './successful-account-creation/successful-account-creation.component';
import { SuccessfulCreditCardCreationComponent } from './successful-credit-card-creation/successful-credit-card-creation.component';
import { InvitationRegisterComponent } from './invitation-register/invitation-register.component';
import { BondingComponent } from './bonding/bonding/bonding.component';
import { BondingSuccessfullyCreatedComponent } from './bonding/bonding-successfully-created/bonding-successfully-created.component';
import { EndingBondingComponent } from './bonding/ending-bonding/ending-bonding.component';
import { PrincipalityCreditCardComponent } from './principality-credit-card/principality-credit-card.component';
const routes: Routes = [
  {
    path: 'principality-credit-card',
    component: PrincipalityCreditCardComponent,
  },
  {
    path: 'detail-account-creation',
    component: DetailAccountCreationComponent,
  },
  {
    path: 'bonding',
    component: BondingComponent,
  },
  {
    path: 'bonding-successfully',
    component: BondingSuccessfullyCreatedComponent,
  },
  {
    path: 'ending-bonding',
    component: EndingBondingComponent,
  },
  {
    path: 'successful-account-creation',
    component: SuccessfulAccountCreationComponent,
  },
  {
    path: 'account-info-creation',
    component: AccountInfoCreationComponent,
  },
  {
    path: 'successful-credit-card-creation',
    component: SuccessfulCreditCardCreationComponent,
  },
  {
    path: 'invitation-register',
    component: InvitationRegisterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class SignOnRoutes { }
